import {
  getContentfulAssetUrlandAlt,
  getContentfulField,
} from 'common/components';
import { useClassName } from 'common/hooks';
import React from 'react';
import './passes-and-bundles.less';
import { Intro } from './Intro/Intro';
import { Title } from './Title/Title';
import { TicketsCards } from './TicketsCards/TicketsCards';
import { parseTicketsCards } from 'public/helpers/contentful/parser';

export const PassesAndBundles = ({ venue }) => {
  const className = useClassName('PassesAndBundles');
  const mainColor = getContentfulField(venue.parkScreen?.mainColor);
  const tertiaryColor = getContentfulField(venue.parkScreen?.tertiaryColor);

  const passesAndBundlesTitle = getContentfulField(
    venue.parkScreen.passesAndBundlesTitle
  );
  const passesAndBundlesText = getContentfulField(
    venue.parkScreen.passesAndBundlesText
  );

  const passesAndBundlesWavesFields = getContentfulField(
    venue.parkScreen?.passesAndBundleWaves
  ).fields;

  const passesAndBundlesWaves = {
    desktop: getContentfulAssetUrlandAlt(passesAndBundlesWavesFields.desktop),
  };

  const petAssetFields = getContentfulField(venue.parkScreen?.pet).fields;

  const pet = {
    desktop: getContentfulAssetUrlandAlt(petAssetFields.desktop),
    tablet: getContentfulAssetUrlandAlt(petAssetFields.tablet),
    mobile: getContentfulAssetUrlandAlt(petAssetFields.mobile),
  };

  const passesAndBundlesTitleText = 'Passes & Bundles';
  const passesAndBundlesTitleDescription = getContentfulField(
    venue.parkScreen.passesAndBundlesDescription
  );

  const ticketsCards = parseTicketsCards(venue.parkScreen?.ticketsCards);

  return (
    <div className={className('container')}>
      <Intro
        title={passesAndBundlesTitle}
        description={passesAndBundlesText}
        pet={pet}
        waves={passesAndBundlesWaves}
        mainColor={mainColor}
        tertiaryColor={tertiaryColor}
      />
      <Title
        title={passesAndBundlesTitleText}
        description={passesAndBundlesTitleDescription}
        tertiaryColor={tertiaryColor}
        ticketsCards={ticketsCards}
      />

      <TicketsCards ticketsCards={ticketsCards} tertiaryColor={tertiaryColor} />
    </div>
  );
};
